import React from 'react';
import '../css/TechStack.css';

const skills = [
  { name: 'React',       level: 90 },
  { name: 'Node.js',     level: 85 },
  { name: 'Flask',       level: 80 },
  { name: 'MongoDB',     level: 82 },
  { name: 'TypeScript',  level: 75 },
  { name: 'GraphQL',     level: 70 },
  { name: 'Ollama AI',   level: 78 },   // 🆕 added here
];

export default function TechStack() {
  return (
    <section id="techstack" className="techstack">
      <h2 className="techstack-title">Tech&nbsp;Stack</h2>

      <div className="skills-grid">
        {skills.map((s, i) => (
          <div className="skill-card" key={i}>
            <span className="skill-name">{s.name}</span>
            <div className="bar-wrap">
              <div className="bar-fill" style={{ width: `${s.level}%` }} />
            </div>
            <span className="skill-level">{s.level}%</span>
          </div>
        ))}
      </div>
    </section>
  );
}
